// extracted by mini-css-extract-plugin
export default {"container":"CountdownCard_container__tdmZ4","containerWithWallet":"CountdownCard_containerWithWallet__DkEsp","countDown":"CountdownCard_countDown__QYWtt"};